/* eslint-disable react/no-multi-comp */

import { getSubStepValues } from '#models/general/steps';
import { getSelectField } from '#utils/select';
import { FROM_0_TO_9999_3_DECIMAL_REGEX } from '#utils/string/regex';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';
import Input from '#components/general/Input';

import { MASHING_AND_COLLECTION_FIELDS, MASH_SUBSTEPS_IDS } from './constants';
import styles from './styles.module.scss';

export const YEAST_VARIETY_OPTIONS = {
  SAFSPIRIT_M1: 'safspirit_m1',
  SAFSPIRIT_D53: 'safspirit_d53',
  DISTILAMAX: 'distilamax',
  MANUAL: 'manual'
};

export const getMashingInfo = ({ values, errors }) => {
  const getMashingAndCollectionValues = getSubStepValues(
    MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION,
    values,
    errors
  );
  const isManualYeast = yeast => values[yeast] === 'manual';
  const isFirstYeastManual = isManualYeast(MASHING_AND_COLLECTION_FIELDS.FIRST_YEAST_VARIETY);
  const isSecondYeastManual = isManualYeast(MASHING_AND_COLLECTION_FIELDS.SECOND_YEAST_VARIETY);
  return [
    {
      key: 'times',
      Component: AdelphiFieldsRow,
      className: styles.mashingAndCollectionMoreInfoRow,
      fields: [
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.YEAST_MANAGEMENT),
          Component: Input,
          noMargin: true
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.YEAST_PITCHED_TIME),
          Component: Input,
          type: 'time',
          noMargin: true
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.DRAFF_OUT_START_TIME),
          Component: Input,
          type: 'time',
          noMargin: true
        }
      ]
    },
    {
      key: 'weights',
      Component: AdelphiFieldsRow,
      className: styles.mashingAndCollectionMoreInfoRow,
      fields: [
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.FIRST_YEAST_WEIGHT),
          Component: Input,
          measure: MEASURE_TYPES.KILOGRAMS,
          needsRegex: true,
          customRegex: FROM_0_TO_9999_3_DECIMAL_REGEX,
          noMargin: true
        },
        {
          ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.SECOND_YEAST_WEIGHT),
          Component: Input,
          measure: MEASURE_TYPES.KILOGRAMS,
          needsRegex: true,
          customRegex: FROM_0_TO_9999_3_DECIMAL_REGEX,
          noMargin: true
        }
      ]
    },
    getSelectField({
      field: MASHING_AND_COLLECTION_FIELDS.FIRST_YEAST_VARIETY,
      substep: MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION,
      manualField: MASHING_AND_COLLECTION_FIELDS.FIRST_YEAST_VARIETY_MANUAL,
      fieldRowClassName: styles.mashingAndCollectionSelectRow,
      selectClassName: !isFirstYeastManual && styles.selectYeastVariety,
      values,
      options: YEAST_VARIETY_OPTIONS,
      getValues: getMashingAndCollectionValues,
      needsManualInput: isFirstYeastManual
    }),
    getSelectField({
      field: MASHING_AND_COLLECTION_FIELDS.SECOND_YEAST_VARIETY,
      substep: MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION,
      manualField: MASHING_AND_COLLECTION_FIELDS.SECOND_YEAST_VARIETY_MANUAL,
      fieldRowClassName: styles.mashingAndCollectionSelectRow,
      selectClassName: !isSecondYeastManual && styles.selectYeastVariety,
      values,
      options: YEAST_VARIETY_OPTIONS,
      getValues: getMashingAndCollectionValues,
      needsManualInput: isSecondYeastManual
    }),
    {
      ...getMashingAndCollectionValues(MASHING_AND_COLLECTION_FIELDS.FAILURE),
      Component: Input,
      noMargin: true,
      className: styles.mashingAndCollectionMoreInfoRow
    }
  ];
};
